import React from 'react';
import styles from '../ChatWidget.module.scss';

interface ChatFabProps {
  onClick: () => void;
}

export default function ChatFab(props: ChatFabProps) {
  return (
    <button
      type="button"
      className={styles.fab}
      onClick={props.onClick}
      aria-label="Open chat"
      data-testid="chat-fab"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
          fill="white"
        />
        <path d="M7 9H17V11H7V9ZM7 5H17V7H7V5ZM7 13H14V15H7V13Z" fill="white" />
      </svg>
    </button>
  );
}
